import { Weekday } from '@portal/enum/daysOfTheWeek';
import { DateTime } from 'luxon';

const isHoliday = (date: DateTime, holidays: string[]) => {
  return holidays.some((holiday) => holiday === date.toISODate());
};

const isWeekend = (date: DateTime) => {
  const day = date.weekday;
  return day === Weekday.SATURDAY || day === Weekday.SUNDAY;
};

const isInvalidDate = (date: DateTime, holidaysArray: string[]) => {
  return isHoliday(date, holidaysArray) || isWeekend(date);
};

export default isInvalidDate;
